import React, { useEffect, useState } from "react";
import LogoKostrad from "../../assets/images/2026/general/logo-kostrad.png";
import KostradRunText from "../../assets/images/2026/general/kostrad-run-text.png";
import BtnRegisterNow from "../../assets/images/2026/general/btn-register-now.png";
import LogoYoutube from "../../assets/images/2026/general/logo-youtube.png";
import LogoInstagram from "../../assets/images/2026/general/logo-instagram.png";
import LogoWhatsapp from "../../assets/images/2026/general/logo-whatsapp.png";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Navlink from "./Navlink";
import DesktopNavLink from "./DesktopNavLink";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
// import { setLocale } from "../../redux/Slice";
import { useLocation } from "react-router-dom";

import { useLogout } from "../../hooks/useApi";
import { isAuthenticated } from "../../lib/api.ts";

// import { Link } from "react-router-dom";
export default function Navbar() {
    const { t, i18n } = useTranslation();
    const navbarData = t("navbar", { returnObjects: true });
    const [navbar, setNavbar] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const { pathname } = location;
    const logoutMutation = useLogout();
    const isAuth = isAuthenticated();

    const isOpenRegistration = process.env.REACT_APP_IS_OPEN_REGISTRATION === "true";

    // const onChangeLocale = (lang) => {
    //     i18n.changeLanguage(lang);
    //     dispatch(setLocale(lang));
    // };

    const isAlternateNavbar = () => {
        if (pathname === '/contact-us') {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.scrollY > 0;
            setIsScrolled(scrolled);
        };

        window.addEventListener("scroll", handleScroll);

        // Membersihkan event listener saat komponen dibongkar
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const [showChild, setShowChild] = useState(false);

    const generateStyleEn = () => {
        if (isAlternateNavbar()) {
            if (i18n.language === "en") {
                return "bg-brandYellow text-brandBlue";
            } else {
                return "bg-white text-black";
            }
        } else {
            if (i18n.language === "en") {
                return "bg-brandBlue text-white";
            } else {
                return "bg-white text-brandBlue";
            }
        }
    }

    const generateStyleId = () => {
        if (isAlternateNavbar()) {
            if (i18n.language === "id") {
                return "bg-brandYellow text-brandBlue";
            } else {
                return "bg-white text-brandBlue";
            }
        } else {
            if (i18n.language === "id") {
                return "bg-brandBlue text-white";
            } else {
                return "bg-white text-brandBlue";
            }
        }
    }

    // TODO: REMOVE '/' LATER!
    const isHideMenu = () => {
        if (pathname === '/coming-soon' || pathname === '/countdown') {
            return true;
        } else {
            return false;
        }
    }

    return (
        <nav>
            <div
                className={`w-full fixed z-30 top-0 transition-all duration-500 ease-in-out text-white ${isScrolled || navbar ? "bg-transparent backdrop-blur-lg" : "bg-transparent"
                    }`}
            >
                <div className={`hidden lg:!flex container px-8 mx-auto w-full justify-between lg:w-full md:items-center items-center max-md:py-4`}>
                    <div>
                        <div className="flex items-center justify-between lg:block">
                            <a href="/" className="flex items-center py-4">
                                <img src={LogoKostrad} alt="" className="w-12 md:w-24" />
                                <img src={KostradRunText} alt="" className="w-20 md:w-32" />
                            </a>

                            <div className="lg:hidden">
                                <button
                                    className={`p-2 ${isScrolled ? "text-brand-cream" : "text-brand-cream"
                                        } rounded-md outline-none focus:border-gray-400 focus:border`}
                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? <XMarkIcon width={24} /> : <Bars3Icon className={`${isScrolled || navbar ? 'text-white' : 'text-[#164481]'}`} width={24} />}
                                </button>
                            </div>
                        </div>
                    </div>
                    <nav>
                        <ul className="lg:flex flex-row w-full font-notoSans font-bold gap-x-4 text-white text-xl">
                            {navbarData.map((value, index) => {
                                return value.isHide === false ? (
                                    <div
                                        key={index}
                                        className="relative"
                                        onClick={() =>
                                            value.child ? setShowChild(!showChild) : null
                                        }
                                    >
                                        <DesktopNavLink
                                            label={value.label}
                                            href={value.href}
                                            isButton={value.isButton || false}
                                            child={value.child}
                                            isScrolled={isScrolled}
                                            navbar={navbar}
                                        />

                                        {value.child ? (
                                            <div
                                                className={`mt-2 ml-6 ${showChild ? "block md:hidden" : "hidden"
                                                    }`}
                                            >
                                                <ul className="space-y-3">
                                                    {value.child.map((value, index) => {
                                                        if (value.isHide) return null;

                                                        return <li key={index + 3}>
                                                            <a href={value.href}>{value.label}</a>
                                                        </li>;
                                                    })}
                                                </ul>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null;
                            })}
                            <li className="cursor-pointer flex items-center"><a href="https://www.instagram.com/kostradrun_/" target="_blank" rel="noopener noreferrer"><img src={LogoInstagram} alt="" className="w-6" /></a></li>
                            <li className="cursor-pointer flex items-center"><a href="https://wa.me/6282124341077" target="_blank" rel="noopener noreferrer"><img src={LogoWhatsapp} alt="" className="w-6" /></a></li>
                            <li className="cursor-pointer flex items-center"><a href="https://www.youtube.com/@PeneranganKostrad" target="_blank" rel="noopener noreferrer"><img src={LogoYoutube} alt="" className="w-6" /></a></li>
                        </ul>
                    </nav>
                    <div>
                        <div className="flex items-center justify-between lg:block">
                            <a href="/registration" className="flex items-center">
                                <img src={BtnRegisterNow} alt="" className="w-24 md:w-56 -mt-4 cursor-pointer hover:scale-105 transition-all duration-300" onClick={() => window.location.href = "/registration"} />
                            </a>

                            <div className="lg:hidden">
                                <button
                                    className={`p-2 ${isScrolled ? "text-brand-cream" : "text-brand-cream"
                                        } rounded-md outline-none focus:border-gray-400 focus:border`}
                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? <XMarkIcon width={24} /> : <Bars3Icon className={`${isScrolled || navbar ? 'text-white' : 'text-[#164481]'}`} width={24} />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* mobile navbar */}
                <div className={`block lg:hidden container max-w-[100vw] w-full justify-between items-center max-md:pt-4`}>
                    <div className="px-8 mx-auto">
                        <div className="flex items-center justify-between lg:block">
                            <a href="/" className="flex items-center py-2">
                                <img src={LogoKostrad} alt="" className="w-12 md:w-24" />
                                <img src={KostradRunText} alt="" className="w-20 md:w-32" />
                            </a>

                            <a href="/registration" className="flex items-center">
                                <img src={BtnRegisterNow} alt="" className="w-24 2xl:w-60 md:w-48 cursor-pointer hover:scale-105 transition-all duration-300" onClick={() => window.location.href = "/registration"} />
                            </a>
                        </div>
                    </div>
                    {!isHideMenu() && <div className={`bg-brandDarkGreen w-full transition-all duration-300 ${isScrolled || navbar ? "lg:!hidden" : "md:block"}`}>
                        <div className="flex items-end justify-end mx-6">
                            <div className="lg:hidden">
                                <button
                                    className={`p-2 ${isScrolled ? "text-brand-cream" : "text-brand-cream"
                                        } rounded-md outline-none focus:border-gray-400 focus:border`}
                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? <XMarkIcon className="text-white" width={24} /> : <Bars3Icon className={`text-white`} width={24} />}
                                </button>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className={`block lg:hidden px-8 mx-auto w-full justify-between items-center bg-white`}>
                    <div></div>
                    <div>
                        <div
                            className={`flex-1 w-full justify-self-end pb-2 mt-2 2xl:text-base text-sm duration-300 ${navbar || (window.innerWidth >= 1024) ? "block" : "hidden"} ${window.innerWidth >= 720 ? "lg:!block" : "md:!block"}`}
                        >
                            <ul
                                className={`w-full items-end justify-end duration-300 ${isScrolled ? "text-white" : "text-black"
                                    } font-poppins antialiased text-right pt-2`}
                            >
                                {/* <div className="flex gap-x-2 items-end justify-end">
                                    <li>
                                        <button
                                            onClick={() => onChangeLocale("en")}
                                            className={`uppercase font-bold rounded-md text-black px-3 py-1 transition-all duration-300 ${generateStyleEn()}`}
                                        >
                                            ENG
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => onChangeLocale("id")}
                                            className={`uppercase font-bold rounded-md text-black px-3 py-1 transition-all duration-300 ${generateStyleId()}`}
                                        >
                                            ID
                                        </button>
                                    </li>
                                </div> */}
                                {navbarData.map((value, index) => {
                                    return value.isHide === false ? (
                                        <div
                                            key={index}
                                            className="relative border-b border-brandDarkGreen py-2"
                                            onClick={() =>
                                                value.child ? setShowChild(!showChild) : null
                                            }
                                        >
                                            <Navlink
                                                label={value.label}
                                                href={value.href}
                                                isButton={value.isButton || false}
                                                child={value.child}
                                                isScrolled={isScrolled}
                                                navbar={navbar}
                                            />

                                            {value.child ? (
                                                <div
                                                    className={`mt-2 pb-2 ml-6 ${showChild ? "block md:hidden" : "hidden"
                                                        }`}
                                                >
                                                    <ul className="space-y-3">
                                                        {value.child.map((value, index) => {
                                                            if (value.isHide) return null;

                                                            return <li key={index + 3}>
                                                                <a href={value.href} className="uppercase">{value.label}</a>
                                                            </li>;
                                                        })}
                                                    </ul>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null;
                                })}
                                {isOpenRegistration && (
                                    !isAuth ? (
                                        <div className="relative border-b border-brandYellow">
                                            <a href="/login">
                                                <span className="font-poppins text-base 2xl:text-lg relative group font-bold !text-black uppercase transition-all duration-300 cursor-pointer">{t("home.login")}</span>
                                            </a>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="relative border-b border-brandYellow">
                                                <a href="/profile">
                                                    <span className="font-poppins text-base 2xl:text-lg relative group font-normal !text-black uppercase hover:font-semibold transition-all duration-300 cursor-pointer">{t("home.profile")}</span>
                                                </a>
                                            </div>
                                            <div className="relative border-b border-brandYellow">
                                                <span onClick={(e) => {
                                                    e.preventDefault();
                                                    logoutMutation.mutate(undefined, {
                                                        onSuccess: () => {
                                                            window.location.href = "/";
                                                        }
                                                    });
                                                }} className="font-poppins text-base 2xl:text-lg relative group font-normal !text-black uppercase hover:font-semibold transition-all duration-300 cursor-pointer">{t("home.logout")}</span>
                                            </div>
                                        </>
                                        )
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* mobile navbar end */}
            </div>
        </nav>
    );
}
